import us from '../../defines';

export function EdgeNav (uScope, viewport, autoPan) {
  const self = this;

  const jVpDiv = viewport.vpDivGet('outer');
  let jEdgeNavDivs;

  const edgeNavSpecs = {
    dim: 29
  };

    /**
     * This function positions and sizes the edge navigation divs in the viewport.
     */
  this.resize = function () {
    const vpDivDims = viewport.vpDivDimsGet();
    const w = vpDivDims.w;
    const h = vpDivDims.h;
    const dim = edgeNavSpecs.dim;

    for (let i = 0; i < jEdgeNavDivs.length; i++) {
      const jEdgeNavDiv = jEdgeNavDivs.eq(i);
      const side = jEdgeNavDiv.attr('side');

      if (side == 'left') jEdgeNavDiv.css({'left': 0, 'top': 0, 'width': dim, 'height': h});
      else if (side == 'right') jEdgeNavDiv.css({'left': w - dim, 'top': 0, 'width': dim, 'height': h});
      else if (side == 'top') jEdgeNavDiv.css({'left': 0, 'top': 0, 'width': w, 'height': dim});
      else if (side == 'bottom') jEdgeNavDiv.css({'left': 0, 'top': h - dim, 'width': w, 'height': dim});
    }
  };

  /**
     * This function creates and adds the edge navigation divs to the viewport.
     */
  self.init = function () {
    if (jEdgeNavDivs) {
      return;
    }

    const template = ['top', 'left', 'right', 'bottom']
      .map(side => `<div class="${us.clsEDGEDIV} ${us.clsOVERLAY}" side="${side}"></div>`)
      .join('\n');

    jEdgeNavDivs = $(template);
    jVpDiv.append(jEdgeNavDivs);

    self.resize();

    jEdgeNavDivs.on('click', function (e) {
      autoPan.onOffToggle();
      return false;
    });

    viewport.events.on('viewport:resize', self.resize);
  };
}
